'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.1.valueOf);



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/this-number-value.js
// module id = 1415
// module chunks = 0